/* eslint-disable no-empty-function */
class AbstractNotificationService {
    static schedules = {};

    static setup() {}

    static subscribeSystemScope() {
        return () => {};
    }

    static subscribeAppScope() {
        return () => {};
    }

    static async getInitialNotification() {}

    static async getNotification() {}

    static async scheduleNotification() {}

    static async cancelScheduledNotification() {}

    static checkPermissions() {}

    static setCurrentSchedules() {}
}

export default AbstractNotificationService;
